export default __webpack_public_path__ + "static/media/menu_bottom.b6134b3f.svg";